export const lineItemProps = {
  type: Object,
  required: true
}

export const lineItemGroupProps = {
  type: Object,
  required: true
}
